export enum OperationLegalStatusEnumFR {
  EN_FORMATION = 'EN_FORMATION',
  CONSTITUE = 'CONSTITUE',
}

export enum OperationLegalStatusEnum {
  IN_FORMATION = 'IN_FORMATION',
  MADE_UP = 'MADE_UP',
}

export const translateOperationLegalStatus = (ols: OperationLegalStatusEnumFR): OperationLegalStatusEnum => {
  switch (ols) {
    case OperationLegalStatusEnumFR.EN_FORMATION:
      return OperationLegalStatusEnum.IN_FORMATION;
    case OperationLegalStatusEnumFR.CONSTITUE:
      return OperationLegalStatusEnum.MADE_UP;
  }
};
